// Browser-safe event emitter.
//
// Do NOT `import { EventEmitter } from "events"` here. Vite externalises Node
// built-ins for browser builds, so "events" resolves to __vite-browser-external,
// which exports nothing, and the production build fails with:
//   "EventEmitter" is not exported by "__vite-browser-external:events"
// Only on/off/emit are used by callers, so a local implementation is enough and
// keeps a Node polyfill out of the bundle.

class EventEmitter {
	constructor() {
		this.listeners = new Map();
	}

	on(event, callback) {
		if (!this.listeners.has(event)) this.listeners.set(event, new Set());
		this.listeners.get(event).add(callback);
		return this;
	}

	off(event, callback) {
		this.listeners.get(event)?.delete(callback);
		return this;
	}

	once(event, callback) {
		const wrapper = (...args) => {
			this.off(event, wrapper);
			callback(...args);
		};
		return this.on(event, wrapper);
	}

	emit(event, ...args) {
		const callbacks = this.listeners.get(event);
		if (!callbacks?.size) return false;
		// Copy first: a listener may unsubscribe itself during emit.
		for (const callback of [...callbacks]) callback(...args);
		return true;
	}

	removeAllListeners(event) {
		if (event === undefined) this.listeners.clear();
		else this.listeners.delete(event);
		return this;
	}
}

const eventEmitter = new EventEmitter();

export default eventEmitter;
